var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.0007C5.92487 23.0007 1 18.0759 1 12.0007C1 5.9256 5.92487 1.00073 12 1.00073C18.0751 1.00073 23 5.9256 23 12.0007C23 18.0759 18.0751 23.0007 12 23.0007ZM19.3997 17.1251C20.4087 15.6708 21 13.9048 21 12.0007C21 7.03017 16.9706 3.00073 12 3.00073C7.02944 3.00073 3 7.03017 3 12.0007C3 13.9049 3.59134 15.6709 4.60039 17.1252C5.72058 15.6452 8.34637 15.0061 11.9505 15.0003C9.73497 14.9772 8.00003 13.4026 8.00003 10.0006C8.00003 7.75634 9.57913 6.00058 12 6.00058C14.4142 6.00058 16 7.92216 16 10.2006C16 13.4556 14.2448 14.9776 12.0499 15.0003C15.6538 15.0061 18.2795 15.6452 19.3997 17.1251ZM17.9649 18.7403C17.6725 17.6878 15.5698 17.0003 12.0001 17.0003C8.43023 17.0003 6.32753 17.6878 6.03531 18.7405C7.62329 20.1469 9.71193 21.0007 12 21.0007C14.2881 21.0007 16.3769 20.1468 17.9649 18.7403ZM10.0001 10.0004C10.0001 12.2697 10.8183 13.0004 12.0001 13.0004C13.1778 13.0004 14.0001 12.2988 14.0001 10.2004C14.0001 8.95085 13.2157 8.00043 12.0001 8.00043C10.7338 8.00043 10.0001 8.81626 10.0001 10.0004Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.07678e089b8e2a3bd282c83736440d77.svg";
export { ForwardRef as ReactComponent };